import { Grid, Skeleton } from "@mui/material";

export default function LoadingSkeleton() {
    return (
        <Grid
            container
            spacing={2}
            sx={{
                marginTop: 3,
                justifyContent: 'center',
            }}
        >
            {[...Array(6)].map((_, index) => (
                <Grid key={index} size={{ xs: 12, md: 6, lg: 4 }}>
                    <Skeleton key={index} variant="rectangular" width="100%" height="80px" sx={{ borderRadius: 2, }} />
                </Grid>
            ))}
        </Grid>
    );
};